import api from "../../api/axiosInstance";
import { setLoading, setItems, setError, addItem, updateItem, removeItem } from "../slices/blogsSlice";

export const fetchBlogs = () => async (dispatch) => {
    dispatch(setLoading());
    try {
        const res = await api.get("/blogs?all=true");
        dispatch(setItems(res.data));
    } catch (err) {
        dispatch(setError(err.response?.data?.message || "Failed to load blogs"));
        throw err;
    }
};

export const createBlog = (formData) => async (dispatch) => {
    try {
        const res = await api.post("/blogs", formData);
        dispatch(addItem(res.data));
    } catch (err) { throw err; }
};

export const editBlog = ({ id, formData }) => async (dispatch) => {
    try {
        const res = await api.put(`/blogs/${id}`, formData);
        dispatch(updateItem(res.data));
    } catch (err) { throw err; }
};

export const removeBlog = (id) => async (dispatch) => {
    try {
        await api.delete(`/blogs/${id}`);
        dispatch(removeItem(id));
    } catch (err) { throw err; }
};
